import { privacyUrl, publicPrivacyUrl } from 'hatchEndpoints';

export function FetchPrivacyPolicy( companyId, solutionId, locale ) {
    return `${ publicPrivacyUrl }/files/download/${ companyId }/${ solutionId }/${ locale }`;
}


export async function GetAcknowledgement( token, solutionId ) {
    const response = await fetch( `${ privacyUrl }/acceptance/${ solutionId }`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    const data = await response.json();
    return data;
}

export async function PostAcknowledgement( token, solutionId ) {
    const response = await fetch( `${ privacyUrl }/acceptance/${ solutionId }`, {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${ token }`
        }
    } );

    return response;
}
